import axios from "@/axios.js"

export default {
  getCompanyOrRegistrationNo({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/clients/search_company_or_registration/" + item)
        .then((response) => {
          commit('SET_COMPANY_OR_REGISTRATION_NO', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchClientEmail({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/clients/search_client_email/" + item)
        .then((response) => {
          commit('SET_COMPANY_OR_REGISTRATION_NO', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchClient({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/clients/search_client/" + item)
        .then((response) => {
          commit('SET_SEARCHED_CLIENT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getClientsMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_client_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getMasterMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_master_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSatelliteOfficeMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_satellite_office_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getWebMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_web_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getLinkedinMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_linkedin_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPhoneMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_phone_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSicCodeMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_siccode_metadata/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getVertical({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/clients/get_vertical/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCountry({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/clients/get_country/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getParent({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/clients/${item}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getParentCompany({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/clients/get_parent_company/${item}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getGroupCompanies({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/clients/get_grouped_companies/${item}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  checkLinkedinExists({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/clients/check_linkedin_exists", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  checkWebsiteExists({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/clients/check_website_exists", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  checkCompanyExists({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/clients/check_company_exists", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchAutocomplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/clients/search/" + item)
        .then((response) => {
          // // console.log(response)
          commit('SET_AUTOCOMPLETE_DATA', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateClient({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/clients/update_client", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('ADD_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateClientEmail({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/clients/update_client_email", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addClient({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/clients/add_clients", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('ADD_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addClientEmail({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/clients/add_clients_email", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPhoneTypes({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/clients/phone_types")
        .then((response) => {
          // // console.log(response)
          commit('SET_PHONE_TYPES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getVerticals({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/clients/verticals/" + item)
        .then((response) => {
          commit('SET_VERTICALS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCountries({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/clients/countries/" + item)
        .then((response) => {
          commit('SET_COUNTRIES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllClients({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      // console.log(item1)
      axios.get("/api/clients/" + item.page_no + "/" + item.per_page)
        .then((response) => {
          commit('SET_CLIENTS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllClientsEmail({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      // console.log(item1)
      axios.get("/api/clients/client_email/" + item.page_no + "/" + item.per_page)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchClient({
    commit
  },clientId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/clients/${clientId}`)
        .then((response) => {
          commit('SET_SEARCHED_CLIENT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchClientEmail({
    commit
  },clientEmailId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/clients/client_email/${clientEmailId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchClientEmailWithClientId({
    commit
  },clientId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/clients/client_email_with_client_id/${clientId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
    fetchClientList({
      commit
    },item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/clients/${item}`)
        .then((response) => {
          commit('SELECTED_CLIENT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeClient({
    commit
  }, clientId) {
    return new Promise((resolve, reject) => {
      // alert(clientId)
      axios.delete(`/api/clients/${clientId}`)
        .then((response) => {
          commit('REMOVE_CLIENT', clientId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeClientEmail({
    commit
  }, clientEmailId) {
    return new Promise((resolve, reject) => {
      // alert(clientId)
      axios.delete(`/api/clients/client_email/${clientEmailId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
